import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const EmployersRatingScaleSmallKindDefault = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.63235 4.09095L8.63408 4.08972C8.86241 3.9256 9.14425 3.85943 9.41921 3.90437C9.69394 3.94928 9.94172 4.10188 10.1085 4.3312C10.4473 4.80369 10.3396 5.4623 9.86656 5.80332C9.63826 5.96737 9.35647 6.03351 9.08158 5.98858C8.80675 5.94366 8.55892 5.79098 8.3921 5.56156C8.31172 5.4498 8.25389 5.32264 8.22223 5.18745C8.19054 5.05204 8.18579 4.91151 8.2083 4.77417C8.2308 4.63683 8.28006 4.50566 8.35297 4.38833C8.42591 4.27101 8.52096 4.16998 8.63235 4.09095Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <rect
                x={8.00195}
                y={7.68994}
                width={2.4971}
                height={3.91953}
                rx={0.5}
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <path
                d="M5.50098 9.74512C5.50098 9.46897 5.72483 9.24512 6.00098 9.24512H7.49807C7.77421 9.24512 7.99807 9.46898 7.99807 9.74512V11.6095H6.00098C5.72483 11.6095 5.50098 11.3857 5.50098 11.1095V9.74512Z"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Employers'
);
export default EmployersRatingScaleSmallKindDefault;
